import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { useLang } from "@/i18n";
import { WHY_CHOOSE } from "@/data/site";

export default function WhyChoose() {
  const { t } = useLang();
  return (
    <section id="why" className="py-20 md:py-28 bg-slate-50/60" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-turq-dark">{t("why_label")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-3 tracking-tight">{t("why_title")}</h2>
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-5">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.BadgeCheck;
            return (
              <motion.div key={w.title} initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
                className="bg-white rounded-2xl p-6 text-center border border-slate-100 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.06)] hover:shadow-[0_20px_50px_-15px_rgba(0,180,216,0.2)] hover:-translate-y-1 transition-all duration-300" data-testid={`why-card-${i}`}>
                <div className="w-16 h-16 rounded-2xl bg-turq/10 flex items-center justify-center text-turq-dark mx-auto">
                  <Icon className="w-8 h-8" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading font-semibold text-navy mt-4 text-base">{w.title}</h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
